import { render } from "./myFooter.vue?vue&type=template&id=4a5f67ef&scoped=true"
const script = {}

import "./myFooter.vue?vue&type=style&index=0&id=4a5f67ef&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5f67ef"]])

export default __exports__